







import VueOptions from '@utils/VueOptions'

settings = 
  name: 'Steps'
  vue:
    data: ->  
      error: null
    props: ['wizard']
    methods:
      stepsAreValid: -> 
        uniqueSteps = [...new Set(@wizard.steps.map (s) -> s.name)]
        @error = "Duplicate step" if uniqueSteps.length isnt @wizard.steps.length
        !@error
    mounted: ->
      @wizard.initializeWizard()

export default VueOptions.vue settings
